/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../../_chunks/dep-46de7b2e.js';
import { i as isUndefined_1 } from '../../../_chunks/dep-036ad2cc.js';
import { i as isBoolean_1 } from '../../../_chunks/dep-7dad86aa.js';
import { p as pick_1 } from '../../../_chunks/dep-4f1e1217.js';
import { o as omit_1 } from '../../../_chunks/dep-7b67cdbf.js';
import log from '../log/log.js';
import '../../../_chunks/dep-c3f1141e.js';
import '../../../_chunks/dep-4941ebe7.js';
import '../../../_chunks/dep-e9b62d1f.js';
import '../../../_chunks/dep-7dce2c26.js';
import '../../../_chunks/dep-ca64038e.js';
import '../../../_chunks/dep-77e34309.js';
import '../../../_chunks/dep-c1f93350.js';
import '../../../_chunks/dep-9acbc163.js';
import '../../../_chunks/dep-7b52f080.js';
import '../../../_chunks/dep-f10515e8.js';
import '../../../_chunks/dep-88cd50bf.js';
import '../../../_chunks/dep-dcb5aa2a.js';
import '../../../_chunks/dep-ee4bf8c2.js';
import '../../../_chunks/dep-33ffecad.js';
import '../../../_chunks/dep-29cb89ad.js';
import '../../../_chunks/dep-4b8f240e.js';
import '../../../_chunks/dep-934eda0c.js';
import '../../../_chunks/dep-12510d64.js';
import '../../../_chunks/dep-6b568d83.js';
import '../../../_chunks/dep-304e657b.js';
import '../../../_chunks/dep-6506fbc2.js';
import '../../../_chunks/dep-e73d1b75.js';
import '../../../_chunks/dep-c8399d32.js';
import '../../../_chunks/dep-e285f2f8.js';
import '../../../_chunks/dep-09050977.js';
import '../../../_chunks/dep-23d0a0bb.js';
import '../../../_chunks/dep-c00532d4.js';
import '../../../_chunks/dep-f4a320cd.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function getExposedProps(node) {
  var props = pick_1(node, ["value", "label", "data", "actived", "expanded", "checked", "indeterminate", "loading"]);
  return props;
}
function createNodeModel(node) {
  var props = getExposedProps(node);
  var model = _objectSpread(_objectSpread({}, props), {}, {
    getLevel: function getLevel() {
      return node.getLevel();
    },
    getIndex: function getIndex() {
      return node.getIndex();
    },
    isFirst: function isFirst() {
      return node.isFirst();
    },
    isLast: function isLast() {
      return node.isLast();
    },
    isLeaf: function isLeaf() {
      return node.isLeaf();
    },
    insertBefore: function insertBefore(newData) {
      return node.insertBefore(newData);
    },
    insertAfter: function insertAfter(newData) {
      return node.insertAfter(newData);
    },
    appendData: function appendData(data) {
      return node.append(data);
    },
    getPath: function getPath() {
      var nodes = node.getPath();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getParent: function getParent() {
      var _node$parent;
      return (_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.getModel();
    },
    getParents: function getParents() {
      var nodes = node.getParents();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getRoot: function getRoot() {
      var root = node.getRoot();
      return root === null || root === void 0 ? void 0 : root.getModel();
    },
    getSiblings: function getSiblings() {
      var nodes = node.getSiblings();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getChildren: function getChildren(deep) {
      var childrenModel = false;
      var children = node.children;
      if (Array.isArray(children)) {
        if (children.length > 0) {
          if (deep) {
            var nodes = node.walk();
            nodes.shift();
            childrenModel = nodes.map(function (item) {
              return item.getModel();
            });
          } else {
            childrenModel = children.map(function (item) {
              return item.getModel();
            });
          }
        } else {
          childrenModel = false;
        }
      } else if (isBoolean_1(children)) {
        childrenModel = children;
      }
      return childrenModel;
    },
    remove: function remove(value) {
      if (!value) {
        node.remove();
        return;
      }
      var tree = node.tree;
      var targetNode = tree.getNode(value);
      if (!targetNode) {
        log.warnOnce("Tree", "`".concat(value, "` is not exist"));
        return;
      }
      var parents = targetNode.getParents();
      var parentValues = parents.map(function (pnode) {
        return pnode.value;
      });
      if (parentValues.indexOf(node.value) < 0) {
        log.warnOnce("Tree", "`".concat(value, "` is not a childNode of current node"));
        return;
      }
      targetNode.remove();
    },
    setData: function setData(data) {
      var _data = omit_1(data, ["children", "value", "label"]);
      var keys = node.tree.config.keys;
      var dataValue = data[(keys === null || keys === void 0 ? void 0 : keys.value) || "value"];
      var dataLabel = data[(keys === null || keys === void 0 ? void 0 : keys.label) || "label"];
      if (!isUndefined_1(dataValue)) _data.value = dataValue;
      if (!isUndefined_1(dataLabel)) _data.label = dataLabel;
      Object.assign(node.data, _data);
      Object.assign(node, _data);
    }
  });
  return model;
}
function updateNodeModel(model, node) {
  var props = getExposedProps(node);
  Object.assign(model, props);
}

export { createNodeModel, updateNodeModel };
//# sourceMappingURL=tree-node-model.js.map
